import React, { useState } from "react";

import { CalculateContext, TCostingCalculate } from "./CalculateContext.ts";

export const CalculateProvider = ({
  children,
  costingCalculateValue,
}: {
  children: React.ReactNode;
  costingCalculateValue: TCostingCalculate;
}) => {
  const [costingCalculate, setCostingCalculate] = useState<TCostingCalculate>(
    costingCalculateValue,
  );

  return (
    <CalculateContext.Provider
      value={{
        costingCalculate,
        setCostingCalculate,
      }}
    >
      {children}
    </CalculateContext.Provider>
  );
};
